// src/gameLogics/faunaRaceData.js

/**
 * Basis data terpusat dan diperkaya untuk permainan Fauna Race.
 * Setiap kategori sekarang memiliki 15 pertanyaan per tingkat kesulitan
 * untuk mendukung target skor 100 poin dan variasi permainan.
 */

export const faunaData = {
    food: {
        name: "Jenis Makanan",
        icon: "🥩🌿",
        options: ["HERBIVORA", "KARNIVORA", "OMNIVORA"],
        easy: [
            { emoji: "🦁", answer: "KARNIVORA", name: "SINGA" },
            { emoji: "🐄", answer: "HERBIVORA", name: "SAPI" },
            { emoji: "🐻", answer: "OMNIVORA", name: "BERUANG" },
            { emoji: "🦅", answer: "KARNIVORA", name: "ELANG" },
            { emoji: "🐘", answer: "HERBIVORA", name: "GAJAH" },
            { emoji: "🐵", answer: "OMNIVORA", name: "MONYET" },
            { emoji: "🐯", answer: "KARNIVORA", name: "HARIMAU" },
            { emoji: "🐰", answer: "HERBIVORA", name: "KELINCI" },
            { emoji: "🐷", answer: "OMNIVORA", name: "BABI" },
            { emoji: "🦈", answer: "KARNIVORA", name: "HIU" },
            { emoji: "🐎", answer: "HERBIVORA", name: "KUDA" },
            { emoji: "🐶", answer: "OMNIVORA", name: "ANJING" },
            { emoji: "🐺", answer: "KARNIVORA", name: "SERIGALA" },
            { emoji: "🦌", answer: "HERBIVORA", name: "RUSA" },
            { emoji: "🐭", answer: "OMNIVORA", name: "TIKUS" }
        ],
        medium: [
            { emoji: "🦔", answer: "OMNIVORA", name: "LANDAK" },
            { emoji: "🦏", answer: "HERBIVORA", name: "BADAK" },
            { emoji: "🐆", answer: "KARNIVORA", name: "MACAN TUTUL" },
            { emoji: "🦒", answer: "HERBIVORA", name: "JERAPAH" },
            { emoji: "🐨", answer: "HERBIVORA", name: "KOALA" },
            { emoji: "🦘", answer: "HERBIVORA", name: "KANGURU" },
            { emoji: "🐼", answer: "HERBIVORA", name: "PANDA" },
            { emoji: "🦦", answer: "KARNIVORA", name: "BERANG-BERANG LAUT" },
            { emoji: "🐿️", answer: "OMNIVORA", name: "TUPAI" },
            { emoji: "🦝", answer: "OMNIVORA", name: "RAKUN" },
            { emoji: "🐧", answer: "KARNIVORA", name: "PENGUIN" },
            { emoji: "🦢", answer: "OMNIVORA", name: "ANGSA" },
            { emoji: "🐊", answer: "KARNIVORA", name: "BUAYA" },
            { emoji: "🐢", answer: "OMNIVORA", name: "KURA-KURA" },
            { emoji: "🐍", answer: "KARNIVORA", name: "ULAR" }
        ],
        pro: [
            { emoji: "🦇", answer: "OMNIVORA", name: "KELELAWAR" },
            { emoji: "🐳", answer: "KARNIVORA", name: "PAUS" },
            { emoji: "🐙", answer: "KARNIVORA", name: "GURITA" },
            { emoji: "🦞", answer: "OMNIVORA", name: "LOBSTER" },
            { emoji: "🦀", answer: "OMNIVORA", name: "KEPITING" },
            { emoji: "🐝", answer: "HERBIVORA", name: "LEBAH" },
            { emoji: "🐛", answer: "HERBIVORA", name: "ULAT" },
            { emoji: "🦗", answer: "OMNIVORA", name: "JANGKRIK" },
            { emoji: "🕷️", answer: "KARNIVORA", name: "LABA-LABA" },
            { emoji: "🦂", answer: "KARNIVORA", name: "KALAJENGKING" },
            { emoji: "🐌", answer: "HERBIVORA", name: "SIPUT" },
            { emoji: "🦋", answer: "HERBIVORA", name: "KUPU-KUPU" },
            { emoji: "🐜", answer: "OMNIVORA", name: "SEMUT" },
            { emoji: "🦟", answer: "KARNIVORA", name: "NYAMUK" },
            { emoji: "🪱", answer: "HERBIVORA", name: "CACING" }
        ]
    },
    backbone: {
        name: "Tulang Belakang",
        icon: "🦴",
        options: ["VERTEBRATA", "INVERTEBRATA"],
        easy: [
            { emoji: "🐟", answer: "VERTEBRATA", name: "IKAN" },
            { emoji: "🦋", answer: "INVERTEBRATA", name: "KUPU-KUPU" },
            { emoji: "🐍", answer: "VERTEBRATA", name: "ULAR" },
            { emoji: "🐌", answer: "INVERTEBRATA", name: "SIPUT" },
            { emoji: "🐸", answer: "VERTEBRATA", name: "KATAK" },
            { emoji: "🦑", answer: "INVERTEBRATA", name: "CUMI-CUMI" },
            { emoji: "🐦", answer: "VERTEBRATA", name: "BURUNG" },
            { emoji: "🐛", answer: "INVERTEBRATA", name: "ULAT" },
            { emoji: "🐭", answer: "VERTEBRATA", name: "TIKUS" },
            { emoji: "🐝", answer: "INVERTEBRATA", name: "LEBAH" },
            { emoji: "🐱", answer: "VERTEBRATA", name: "KUCING" },
            { emoji: "🕷️", answer: "INVERTEBRATA", name: "LABA-LABA" },
            { emoji: "🐶", answer: "VERTEBRATA", name: "ANJING" },
            { emoji: "🐜", answer: "INVERTEBRATA", name: "SEMUT" },
            { emoji: "🐄", answer: "VERTEBRATA", name: "SAPI" }
        ],
        medium: [
            { emoji: "🦈", answer: "VERTEBRATA", name: "HIU" },
            { emoji: "🦀", answer: "INVERTEBRATA", name: "KEPITING" },
            { emoji: "🐊", answer: "VERTEBRATA", name: "BUAYA" },
            { emoji: "🦞", answer: "INVERTEBRATA", name: "LOBSTER" },
            { emoji: "🐢", answer: "VERTEBRATA", name: "KURA-KURA" },
            { emoji: "🦂", answer: "INVERTEBRATA", name: "KALAJENGKING" },
            { emoji: "🦎", answer: "VERTEBRATA", name: "KADAL" },
            { emoji: "🐙", answer: "INVERTEBRATA", name: "GURITA" },
            { emoji: "🐧", answer: "VERTEBRATA", name: "PENGUIN" },
            { emoji: "🦗", answer: "INVERTEBRATA", name: "JANGKRIK" },
            { emoji: "🦅", answer: "VERTEBRATA", name: "ELANG" },
            { emoji: "🐞", answer: "INVERTEBRATA", name: "KUMBANG" },
            { emoji: "🐳", answer: "VERTEBRATA", name: "PAUS" },
            { emoji: "🦟", answer: "INVERTEBRATA", name: "NYAMUK" },
            { emoji: "🪱", answer: "INVERTEBRATA", name: "CACING" }
        ],
        pro: [
            { emoji: "🦇", answer: "VERTEBRATA", name: "KELELAWAR" },
            { emoji: "🐚", answer: "INVERTEBRATA", name: "KERANG" },
            { emoji: "🐡", answer: "VERTEBRATA", name: "IKAN BUNTAL" },
            { emoji: "🪸", answer: "INVERTEBRATA", name: "KARANG" },
            { emoji: "🦐", answer: "INVERTEBRATA", name: "UDANG" },
            { emoji: "🦒", answer: "VERTEBRATA", name: "JERAPAH" },
            { emoji: "🦪", answer: "INVERTEBRATA", name: "TIRAM" },
            { emoji: "🐨", answer: "VERTEBRATA", name: "KOALA" },
            { emoji: "🐼", answer: "VERTEBRATA", name: "PANDA" },
            { emoji: "🐿️", answer: "VERTEBRATA", name: "TUPAI" },
            { emoji: "🦝", answer: "VERTEBRATA", name: "RAKUN" },
            { emoji: "🦢", answer: "VERTEBRATA", name: "ANGSA" },
            { emoji: "🦩", answer: "VERTEBRATA", name: "FLAMINGO" },
            { emoji: "🦉", answer: "VERTEBRATA", name: "BURUNG HANTU" },
            { emoji: "🐺", answer: "VERTEBRATA", name: "SERIGALA" }
        ]
    },
    habitat: {
        name: "Tempat Hidup",
        icon: "🌎💧",
        options: ["DARAT", "AIR", "AMFIBI"],
        easy: [
            { emoji: "🦁", answer: "DARAT", name: "SINGA" },
            { emoji: "🐟", answer: "AIR", name: "IKAN" },
            { emoji: "🐸", answer: "AMFIBI", name: "KATAK" },
            { emoji: "🐘", answer: "DARAT", name: "GAJAH" },
            { emoji: "🐋", answer: "AIR", name: "PAUS" },
            { emoji: "🐊", answer: "AMFIBI", name: "BUAYA" },
            { emoji: "🐄", answer: "DARAT", name: "SAPI" },
            { emoji: "🐠", answer: "AIR", name: "IKAN HIAS" },
            { emoji: "🐢", answer: "AMFIBI", name: "KURA-KURA" },
            { emoji: "🐎", answer: "DARAT", name: "KUDA" },
            { emoji: "🦈", answer: "AIR", name: "HIU" },
            { emoji: "🐶", answer: "DARAT", name: "ANJING" },
            { emoji: "🐙", answer: "AIR", name: "GURITA" },
            { emoji: "🐍", answer: "DARAT", name: "ULAR" },
            { emoji: "🐒", answer: "DARAT", name: "MONYET" }
        ],
        medium: [
            { emoji: "🦫", answer: "AMFIBI", name: "BERANG-BERANG" },
            { emoji: "🦦", answer: "AMFIBI", name: "BERANG-BERANG LAUT" },
            { emoji: "🐧", answer: "AMFIBI", name: "PENGUIN" },
            { emoji: "🦆", answer: "AMFIBI", name: "BEBEK" },
            { emoji: "🦢", answer: "AMFIBI", name: "ANGSA" },
            { emoji: "🦩", answer: "AMFIBI", name: "FLAMINGO" },
            { emoji: "🐬", answer: "AIR", name: "LUMBA-LUMBA" },
            { emoji: "🦭", answer: "AMFIBI", name: "ANJING LAUT" },
            { emoji: "🦀", answer: "AIR", name: "KEPITING" },
            { emoji: "🦞", answer: "AIR", name: "LOBSTER" },
            { emoji: "🦐", answer: "AIR", name: "UDANG" },
            { emoji: "🐡", answer: "AIR", name: "IKAN BUNTAL" },
            { emoji: "🦒", answer: "DARAT", name: "JERAPAH" },
            { emoji: "🦏", answer: "DARAT", name: "BADAK" },
            { emoji: "🐜", answer: "DARAT", name: "SEMUT" }
        ],
        pro: [
            { emoji: "🦇", answer: "DARAT", name: "KELELAWAR" },
            { emoji: "🐨", answer: "DARAT", name: "KOALA" },
            { emoji: "🦘", answer: "DARAT", name: "KANGURU" },
            { emoji: "🐼", answer: "DARAT", name: "PANDA" },
            { emoji: "🐿️", answer: "DARAT", name: "TUPAI" },
            { emoji: "🦉", answer: "DARAT", name: "BURUNG HANTU" },
            { emoji: "🐺", answer: "DARAT", name: "SERIGALA" },
            { emoji: "🕷️", answer: "DARAT", name: "LABA-LABA" },
            { emoji: "🦂", answer: "DARAT", name: "KALAJENGKING" },
            { emoji: "🐌", answer: "DARAT", name: "SIPUT" },
            { emoji: "🦋", answer: "DARAT", name: "KUPU-KUPU" },
            { emoji: "🐞", answer: "DARAT", name: "KUMBANG" },
            { emoji: "🦟", answer: "DARAT", name: "NYAMUK" },
            { emoji: "🪱", answer: "DARAT", name: "CACING" },
            { emoji: "🪸", answer: "AIR", name: "KARANG" }
        ]
    },
    movement: {
        name: "Cara Bergerak",
        icon: "✈️🏃",
        options: ["TERBANG", "BERJALAN", "BERENANG"],
        easy: [
            { emoji: "🦅", answer: "TERBANG", name: "ELANG" },
            { emoji: "🐘", answer: "BERJALAN", name: "GAJAH" },
            { emoji: "🐟", answer: "BERENANG", name: "IKAN" },
            { emoji: "🦋", answer: "TERBANG", name: "KUPU-KUPU" },
            { emoji: "🦁", answer: "BERJALAN", name: "SINGA" },
            { emoji: "🐋", answer: "BERENANG", name: "PAUS" },
            { emoji: "🐦", answer: "TERBANG", name: "BURUNG" },
            { emoji: "🐄", answer: "BERJALAN", name: "SAPI" },
            { emoji: "🐠", answer: "BERENANG", name: "IKAN HIAS" },
            { emoji: "🐝", answer: "TERBANG", name: "LEBAH" },
            { emoji: "🐎", answer: "BERJALAN", name: "KUDA" },
            { emoji: "🦈", answer: "BERENANG", name: "HIU" },
            { emoji: "🦆", answer: "TERBANG", name: "BEBEK" },
            { emoji: "🐶", answer: "BERJALAN", name: "ANJING" },
            { emoji: "🐙", answer: "BERENANG", name: "GURITA" }
        ],
        medium: [
            { emoji: "🦇", answer: "TERBANG", name: "KELELAWAR" },
            { emoji: "🐧", answer: "BERJALAN", name: "PENGUIN" },
            { emoji: "🐬", answer: "BERENANG", name: "LUMBA-LUMBA" },
            { emoji: "🦢", answer: "TERBANG", name: "ANGSA" },
            { emoji: "🦔", answer: "BERJALAN", name: "LANDAK" },
            { emoji: "🦭", answer: "BERENANG", name: "ANJING LAUT" },
            { emoji: "🦩", answer: "TERBANG", name: "FLAMINGO" },
            { emoji: "🦏", answer: "BERJALAN", name: "BADAK" },
            { emoji: "🦀", answer: "BERJALAN", name: "KEPITING" },
            { emoji: "🦜", answer: "TERBANG", name: "BURUNG BEO" },
            { emoji: "🐆", answer: "BERJALAN", name: "MACAN TUTUL" },
            { emoji: "🦞", answer: "BERENANG", name: "LOBSTER" },
            { emoji: "🦉", answer: "TERBANG", name: "BURUNG HANTU" },
            { emoji: "🦒", answer: "BERJALAN", name: "JERAPAH" },
            { emoji: "🦘", answer: "BERJALAN", name: "KANGURU" }
        ],
        pro: [
            { emoji: "🐌", answer: "BERJALAN", name: "SIPUT" },
            { emoji: "🦑", answer: "BERENANG", name: "CUMI-CUMI" },
            { emoji: "🦟", answer: "TERBANG", name: "NYAMUK" },
            { emoji: "🪱", answer: "BERJALAN", name: "CACING" },
            { emoji: "🦐", answer: "BERENANG", name: "UDANG" },
            { emoji: "🪰", answer: "TERBANG", name: "LALAT" },
            { emoji: "🐜", answer: "BERJALAN", name: "SEMUT" },
            { emoji: "🪸", answer: "BERENANG", name: "KARANG" },
            { emoji: "🐞", answer: "TERBANG", name: "KUMBANG" },
            { emoji: "🕷️", answer: "BERJALAN", name: "LABA-LABA" },
            { emoji: "🐸", answer: "BERJALAN", name: "KATAK" },
            { emoji: "🦂", answer: "BERJALAN", name: "KALAJENGKING" },
            { emoji: "🐊", answer: "BERJALAN", name: "BUAYA" },
            { emoji: "🐢", answer: "BERJALAN", name: "KURA-KURA" },
            { emoji: "🐍", answer: "BERJALAN", name: "ULAR" }
        ]
    },
    reproduction: {
        name: "Berkembang Biak",
        icon: "🥚👶",
        options: ["OVIPAR", "VIVIPAR"],
        easy: [
            { emoji: "🐔", answer: "OVIPAR", name: "AYAM" },
            { emoji: "🐄", answer: "VIVIPAR", name: "SAPI" },
            { emoji: "🐍", answer: "OVIPAR", name: "ULAR" },
            { emoji: "🐘", answer: "VIVIPAR", name: "GAJAH" },
            { emoji: "🦆", answer: "OVIPAR", name: "BEBEK" },
            { emoji: "🐋", answer: "VIVIPAR", name: "PAUS" },
            { emoji: "🐦", answer: "OVIPAR", name: "BURUNG" },
            { emoji: "🐎", answer: "VIVIPAR", name: "KUDA" },
            { emoji: "🐟", answer: "OVIPAR", name: "IKAN" },
            { emoji: "🐶", answer: "VIVIPAR", name: "ANJING" },
            { emoji: "🦅", answer: "OVIPAR", name: "ELANG" },
            { emoji: "🦁", answer: "VIVIPAR", name: "SINGA" },
            { emoji: "🐢", answer: "OVIPAR", name: "KURA-KURA" },
            { emoji: "🐵", answer: "VIVIPAR", name: "MONYET" },
            { emoji: "🐊", answer: "OVIPAR", name: "BUAYA" }
        ],
        medium: [
            { emoji: "🦈", answer: "OVIPAR", name: "HIU" }, // Beberapa vivipar, tapi mayoritas ovipar/ovovivipar
            { emoji: "🐬", answer: "VIVIPAR", name: "LUMBA-LUMBA" },
            { emoji: "🐧", answer: "OVIPAR", name: "PENGUIN" },
            { emoji: "🦭", answer: "VIVIPAR", name: "ANJING LAUT" },
            { emoji: "🦢", answer: "OVIPAR", name: "ANGSA" },
            { emoji: "🦔", answer: "VIVIPAR", name: "LANDAK" },
            { emoji: "🦩", answer: "OVIPAR", name: "FLAMINGO" },
            { emoji: "🦏", answer: "VIVIPAR", name: "BADAK" },
            { emoji: "🦜", answer: "OVIPAR", name: "BURUNG BEO" },
            { emoji: "🐆", answer: "VIVIPAR", name: "MACAN TUTUL" },
            { emoji: "🦉", answer: "OVIPAR", name: "BURUNG HANTU" },
            { emoji: "🦒", answer: "VIVIPAR", name: "JERAPAH" },
            { emoji: "🦎", answer: "OVIPAR", name: "KADAL" },
            { emoji: "🐨", answer: "VIVIPAR", name: "KOALA" },
            { emoji: "🐼", answer: "VIVIPAR", name: "PANDA" }
        ],
        pro: [
            { emoji: "🦇", answer: "VIVIPAR", name: "KELELAWAR" },
            { emoji: " platypus", answer: "OVIPAR", name: "PLATIPUS" }, // Mamalia bertelur
            { emoji: " echidna", answer: "OVIPAR", name: "EKIDNA" }, // Mamalia bertelur
            { emoji: "🐜", answer: "OVIPAR", name: "SEMUT" },
            { emoji: "🐺", answer: "VIVIPAR", name: "SERIGALA" },
            { emoji: "🦋", answer: "OVIPAR", name: "KUPU-KUPU" },
            { emoji: "🐿️", answer: "VIVIPAR", name: "TUPAI" },
            { emoji: "🕷️", answer: "OVIPAR", name: "LABA-LABA" },
            { emoji: "🦘", answer: "VIVIPAR", name: "KANGURU" },
            { emoji: "🦂", answer: "VIVIPAR", name: "KALAJENGKING" }, // Sebagian besar vivipar
            { emoji: "🐝", answer: "OVIPAR", name: "LEBAH" },
            { emoji: "🦦", answer: "VIVIPAR", name: "BERANG-BERANG LAUT" },
            { emoji: "🐌", answer: "OVIPAR", name: "SIPUT" },
            { emoji: "🦝", answer: "VIVIPAR", name: "RAKUN" },
            { emoji: "🦟", answer: "OVIPAR", name: "NYAMUK" }
        ]
    }
};